<template>
    <div class="bg-gradient-to-r from-green-500 to-yellow-600 rounded-xl shadow-lg p-8 text-white mb-8">
      <h1 class="text-4xl font-bold mb-4">Welcome to MinSU Research Portal</h1>
      <p class="text-xl mb-6">Multidisciplinary Research Journal</p>
      <img src="@/assets/mrj.png" alt="Research Portal Logo">
      <div class="flex flex-wrap gap-4">
        <button @click="$emit('update-view', 'browse')" class="px-6 py-3 bg-white text-green-600 rounded-lg font-medium hover:bg-gray-100 transition duration-200">
          Browse Journals
        </button>
        <button @click="$emit('update-view', 'submit')" class="px-6 py-3 border-2 border-white text-white rounded-lg font-medium hover:bg-white hover:bg-opacity-10 transition duration-200">
          Submit Your Research
        </button>
      </div>
    </div>
</template>

